import { render } from "./LyricsDialog.vue?vue&type=template&id=54a7eed4"
import script from "./LyricsDialog.vue?vue&type=script&lang=js"
export * from "./LyricsDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__